/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as authenticatedRouteImport } from './routes/(authenticated)/route'
import { Route as RouteImport } from './routes/route'
import { Route as unauthenticatedSignOutRouteImport } from './routes/(unauthenticated)/sign-out/route'
import { Route as authenticatedReferralsRouteImport } from './routes/(authenticated)/referrals/route'
import { Route as authenticatedDashboardRouteImport } from './routes/(authenticated)/dashboard/route'
import { Route as authenticatedReferralsIdRouteImport } from './routes/(authenticated)/referrals/$id/route'
import { Route as authenticatedPatientsPatientIdRouteImport } from './routes/(authenticated)/patients/$patientId/route'
import { Route as authenticatedEntitiesEntityIdRouteImport } from './routes/(authenticated)/entities/$entityId/route'
import { Route as authenticatedAssessmentsIdRouteImport } from './routes/(authenticated)/assessments/$id/route'
import { Route as authenticatedUsersIndexRouteImport } from './routes/(authenticated)/users/index/route'
import { Route as authenticatedPatientsIndexRouteImport } from './routes/(authenticated)/patients/index/route'
import { Route as authenticatedEntitiesIndexRouteImport } from './routes/(authenticated)/entities/index/route'
import { Route as authenticatedPatientsPatientIdPhysicianSummaryRouteImport } from './routes/(authenticated)/patients/$patientId/physician-summary/route'
import { Route as authenticatedPatientsPatientIdMonthlyCareLogRouteImport } from './routes/(authenticated)/patients/$patientId/monthly-care-log/route'
import { Route as authenticatedPatientsPatientIdCarePlanRouteImport } from './routes/(authenticated)/patients/$patientId/care-plan/route'
import { Route as authenticatedPatientsPatientIdIndexRouteImport } from './routes/(authenticated)/patients/$patientId/index/route'

// Create Virtual Routes

const unauthenticatedForgotPasswordRouteLazyImport = createFileRoute(
  '/(unauthenticated)/forgot-password',
)()
const authenticatedUsersRouteLazyImport = createFileRoute(
  '/(authenticated)/users',
)()
const authenticatedPatientsRouteLazyImport = createFileRoute(
  '/(authenticated)/patients',
)()
const authenticatedMessagesRouteLazyImport = createFileRoute(
  '/(authenticated)/messages',
)()
const authenticatedEntitiesRouteLazyImport = createFileRoute(
  '/(authenticated)/entities',
)()
const authenticatedAssessmentsRouteLazyImport = createFileRoute(
  '/(authenticated)/assessments',
)()
const authenticatedUsersNewRouteLazyImport = createFileRoute(
  '/(authenticated)/users/new',
)()
const authenticatedUsersUserIdRouteLazyImport = createFileRoute(
  '/(authenticated)/users/$userId',
)()
const authenticatedReferralsNewRouteLazyImport = createFileRoute(
  '/(authenticated)/referrals/new',
)()
const authenticatedPatientsNewRouteLazyImport = createFileRoute(
  '/(authenticated)/patients/new',
)()
const authenticatedAssessmentsNewRouteLazyImport = createFileRoute(
  '/(authenticated)/assessments/new',
)()
const authenticatedReferralsIndexRouteLazyImport = createFileRoute(
  '/(authenticated)/referrals/',
)()
const authenticatedAssessmentsIndexRouteLazyImport = createFileRoute(
  '/(authenticated)/assessments/',
)()
const authenticatedReferralsNewPdfImportRouteLazyImport = createFileRoute(
  '/(authenticated)/referrals/new/pdf-import',
)()
const authenticatedReferralsNewImportRouteLazyImport = createFileRoute(
  '/(authenticated)/referrals/new/import',
)()
const authenticatedPatientsPatientIdVitalsRouteLazyImport = createFileRoute(
  '/(authenticated)/patients/$patientId/vitals',
)()
const authenticatedPatientsPatientIdProgramStatusRouteLazyImport =
  createFileRoute('/(authenticated)/patients/$patientId/program-status')()
const authenticatedPatientsPatientIdProblemsRouteLazyImport = createFileRoute(
  '/(authenticated)/patients/$patientId/problems',
)()
const authenticatedPatientsPatientIdPreventativeQmRouteLazyImport =
  createFileRoute('/(authenticated)/patients/$patientId/preventative-qm')()
const authenticatedPatientsPatientIdOutreachRouteLazyImport = createFileRoute(
  '/(authenticated)/patients/$patientId/outreach',
)()
const authenticatedPatientsPatientIdNotesRouteLazyImport = createFileRoute(
  '/(authenticated)/patients/$patientId/notes',
)()
const authenticatedPatientsPatientIdMedicationsRouteLazyImport =
  createFileRoute('/(authenticated)/patients/$patientId/medications')()
const authenticatedPatientsPatientIdMedRecRouteLazyImport = createFileRoute(
  '/(authenticated)/patients/$patientId/med-rec',
)()
const authenticatedPatientsPatientIdLabsRouteLazyImport = createFileRoute(
  '/(authenticated)/patients/$patientId/labs',
)()
const authenticatedPatientsPatientIdInsuranceRouteLazyImport = createFileRoute(
  '/(authenticated)/patients/$patientId/insurance',
)()
const authenticatedPatientsPatientIdInpatientRouteLazyImport = createFileRoute(
  '/(authenticated)/patients/$patientId/inpatient',
)()
const authenticatedPatientsPatientIdDocumentsRouteLazyImport = createFileRoute(
  '/(authenticated)/patients/$patientId/documents',
)()
const authenticatedPatientsPatientIdDiagnosticsRouteLazyImport =
  createFileRoute('/(authenticated)/patients/$patientId/diagnostics')()
const authenticatedPatientsPatientIdDemographicsRouteLazyImport =
  createFileRoute('/(authenticated)/patients/$patientId/demographics')()
const authenticatedPatientsPatientIdCommunicationsRouteLazyImport =
  createFileRoute('/(authenticated)/patients/$patientId/communications')()
const authenticatedPatientsPatientIdCareTeamRouteLazyImport = createFileRoute(
  '/(authenticated)/patients/$patientId/care-team',
)()
const authenticatedPatientsPatientIdCareCallRouteLazyImport = createFileRoute(
  '/(authenticated)/patients/$patientId/care-call',
)()
const authenticatedPatientsPatientIdAssessmentsRouteLazyImport =
  createFileRoute('/(authenticated)/patients/$patientId/assessments')()
const authenticatedPatientsPatientIdAppointmentsRouteLazyImport =
  createFileRoute('/(authenticated)/patients/$patientId/appointments')()
const authenticatedPatientsPatientIdAllergiesRouteLazyImport = createFileRoute(
  '/(authenticated)/patients/$patientId/allergies',
)()
const authenticatedPatientsPatientIdAdvanceDirectivesRouteLazyImport =
  createFileRoute('/(authenticated)/patients/$patientId/advance-directives')()
const authenticatedUsersUserIdIndexRouteLazyImport = createFileRoute(
  '/(authenticated)/users/$userId/',
)()
const authenticatedReferralsNewIndexRouteLazyImport = createFileRoute(
  '/(authenticated)/referrals/new/',
)()

// Create/Update Routes

const authenticatedRouteRoute = authenticatedRouteImport
  .update({
    id: '/(authenticated)',
    getParentRoute: () => rootRoute,
  } as any)
  .lazy(() =>
    import('./routes/(authenticated)/route.lazy').then((d) => d.Route),
  )

const RouteRoute = RouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/route.lazy').then((d) => d.Route))

const unauthenticatedForgotPasswordRouteLazyRoute =
  unauthenticatedForgotPasswordRouteLazyImport
    .update({
      id: '/(unauthenticated)/forgot-password',
      path: '/forgot-password',
      getParentRoute: () => rootRoute,
    } as any)
    .lazy(() =>
      import('./routes/(unauthenticated)/forgot-password/route.lazy').then(
        (d) => d.Route,
      ),
    )

const authenticatedUsersRouteLazyRoute = authenticatedUsersRouteLazyImport
  .update({
    id: '/users',
    path: '/users',
    getParentRoute: () => authenticatedRouteRoute,
  } as any)
  .lazy(() =>
    import('./routes/(authenticated)/users/route.lazy').then((d) => d.Route),
  )

const authenticatedPatientsRouteLazyRoute = authenticatedPatientsRouteLazyImport
  .update({
    id: '/patients',
    path: '/patients',
    getParentRoute: () => authenticatedRouteRoute,
  } as any)
  .lazy(() =>
    import('./routes/(authenticated)/patients/route.lazy').then((d) => d.Route),
  )

const authenticatedMessagesRouteLazyRoute = authenticatedMessagesRouteLazyImport
  .update({
    id: '/messages',
    path: '/messages',
    getParentRoute: () => authenticatedRouteRoute,
  } as any)
  .lazy(() =>
    import('./routes/(authenticated)/messages/route.lazy').then((d) => d.Route),
  )

const authenticatedEntitiesRouteLazyRoute = authenticatedEntitiesRouteLazyImport
  .update({
    id: '/entities',
    path: '/entities',
    getParentRoute: () => authenticatedRouteRoute,
  } as any)
  .lazy(() =>
    import('./routes/(authenticated)/entities/route.lazy').then((d) => d.Route),
  )

const authenticatedAssessmentsRouteLazyRoute =
  authenticatedAssessmentsRouteLazyImport
    .update({
      id: '/assessments',
      path: '/assessments',
      getParentRoute: () => authenticatedRouteRoute,
    } as any)
    .lazy(() =>
      import('./routes/(authenticated)/assessments/route.lazy').then(
        (d) => d.Route,
      ),
    )

const unauthenticatedSignOutRouteRoute =
  unauthenticatedSignOutRouteImport.update({
    id: '/(unauthenticated)/sign-out',
    path: '/sign-out',
    getParentRoute: () => rootRoute,
  } as any)

const authenticatedReferralsRouteRoute =
  authenticatedReferralsRouteImport.update({
    id: '/referrals',
    path: '/referrals',
    getParentRoute: () => authenticatedRouteRoute,
  } as any)

const authenticatedDashboardRouteRoute = authenticatedDashboardRouteImport
  .update({
    id: '/dashboard',
    path: '/dashboard',
    getParentRoute: () => authenticatedRouteRoute,
  } as any)
  .lazy(() =>
    import('./routes/(authenticated)/dashboard/route.lazy').then(
      (d) => d.Route,
    ),
  )

const authenticatedUsersNewRouteLazyRoute = authenticatedUsersNewRouteLazyImport
  .update({
    id: '/new',
    path: '/new',
    getParentRoute: () => authenticatedUsersRouteLazyRoute,
  } as any)
  .lazy(() =>
    import('./routes/(authenticated)/users/new/route.lazy').then(
      (d) => d.Route,
    ),
  )

const authenticatedUsersUserIdRouteLazyRoute =
  authenticatedUsersUserIdRouteLazyImport
    .update({
      id: '/$userId',
      path: '/$userId',
      getParentRoute: () => authenticatedUsersRouteLazyRoute,
    } as any)
    .lazy(() =>
      import('./routes/(authenticated)/users/$userId/route.lazy').then(
        (d) => d.Route,
      ),
    )

const authenticatedReferralsNewRouteLazyRoute =
  authenticatedReferralsNewRouteLazyImport
    .update({
      id: '/new',
      path: '/new',
      getParentRoute: () => authenticatedReferralsRouteRoute,
    } as any)
    .lazy(() =>
      import('./routes/(authenticated)/referrals/new/route.lazy').then(
        (d) => d.Route,
      ),
    )

const authenticatedPatientsNewRouteLazyRoute =
  authenticatedPatientsNewRouteLazyImport
    .update({
      id: '/new',
      path: '/new',
      getParentRoute: () => authenticatedPatientsRouteLazyRoute,
    } as any)
    .lazy(() =>
      import('./routes/(authenticated)/patients/new/route.lazy').then(
        (d) => d.Route,
      ),
    )

const authenticatedAssessmentsNewRouteLazyRoute =
  authenticatedAssessmentsNewRouteLazyImport
    .update({
      id: '/new',
      path: '/new',
      getParentRoute: () => authenticatedAssessmentsRouteLazyRoute,
    } as any)
    .lazy(() =>
      import('./routes/(authenticated)/assessments/new/route.lazy').then(
        (d) => d.Route,
      ),
    )

const authenticatedReferralsIndexRouteLazyRoute =
  authenticatedReferralsIndexRouteLazyImport
    .update({
      id: '/',
      path: '/',
      getParentRoute: () => authenticatedReferralsRouteRoute,
    } as any)
    .lazy(() =>
      import('./routes/(authenticated)/referrals/index/route.lazy').then(
        (d) => d.Route,
      ),
    )

const authenticatedAssessmentsIndexRouteLazyRoute =
  authenticatedAssessmentsIndexRouteLazyImport
    .update({
      id: '/',
      path: '/',
      getParentRoute: () => authenticatedAssessmentsRouteLazyRoute,
    } as any)
    .lazy(() =>
      import('./routes/(authenticated)/assessments/index/route.lazy').then(
        (d) => d.Route,
      ),
    )

const authenticatedReferralsIdRouteRoute = authenticatedReferralsIdRouteImport
  .update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => authenticatedReferralsRouteRoute,
  } as any)
  .lazy(() =>
    import('./routes/(authenticated)/referrals/$id/route.lazy').then(
      (d) => d.Route,
    ),
  )

const authenticatedPatientsPatientIdRouteRoute =
  authenticatedPatientsPatientIdRouteImport
    .update({
      id: '/$patientId',
      path: '/$patientId',
      getParentRoute: () => authenticatedPatientsRouteLazyRoute,
    } as any)
    .lazy(() =>
      import('./routes/(authenticated)/patients/$patientId/route.lazy').then(
        (d) => d.Route,
      ),
    )

const authenticatedEntitiesEntityIdRouteRoute =
  authenticatedEntitiesEntityIdRouteImport
    .update({
      id: '/$entityId',
      path: '/$entityId',
      getParentRoute: () => authenticatedEntitiesRouteLazyRoute,
    } as any)
    .lazy(() =>
      import('./routes/(authenticated)/entities/$entityId/route.lazy').then(
        (d) => d.Route,
      ),
    )

const authenticatedAssessmentsIdRouteRoute =
  authenticatedAssessmentsIdRouteImport
    .update({
      id: '/$id',
      path: '/$id',
      getParentRoute: () => authenticatedAssessmentsRouteLazyRoute,
    } as any)
    .lazy(() =>
      import('./routes/(authenticated)/assessments/$id/route.lazy').then(
        (d) => d.Route,
      ),
    )

const authenticatedUsersIndexRouteRoute = authenticatedUsersIndexRouteImport
  .update({
    id: '/',
    path: '/',
    getParentRoute: () => authenticatedUsersRouteLazyRoute,
  } as any)
  .lazy(() =>
    import('./routes/(authenticated)/users/index/route.lazy').then(
      (d) => d.Route,
    ),
  )

const authenticatedPatientsIndexRouteRoute =
  authenticatedPatientsIndexRouteImport
    .update({
      id: '/',
      path: '/',
      getParentRoute: () => authenticatedPatientsRouteLazyRoute,
    } as any)
    .lazy(() =>
      import('./routes/(authenticated)/patients/index/route.lazy').then(
        (d) => d.Route,
      ),
    )

const authenticatedEntitiesIndexRouteRoute =
  authenticatedEntitiesIndexRouteImport
    .update({
      id: '/',
      path: '/',
      getParentRoute: () => authenticatedEntitiesRouteLazyRoute,
    } as any)
    .lazy(() =>
      import('./routes/(authenticated)/entities/index/route.lazy').then(
        (d) => d.Route,
      ),
    )

const authenticatedReferralsNewPdfImportRouteLazyRoute =
  authenticatedReferralsNewPdfImportRouteLazyImport
    .update({
      id: '/pdf-import',
      path: '/pdf-import',
      getParentRoute: () => authenticatedReferralsNewRouteLazyRoute,
    } as any)
    .lazy(() =>
      import('./routes/(authenticated)/referrals/new/pdf-import/route.lazy').then(
        (d) => d.Route,
      ),
    )

const authenticatedReferralsNewImportRouteLazyRoute =
  authenticatedReferralsNewImportRouteLazyImport
    .update({
      id: '/import',
      path: '/import',
      getParentRoute: () => authenticatedReferralsNewRouteLazyRoute,
    } as any)
    .lazy(() =>
      import('./routes/(authenticated)/referrals/new/import/route.lazy').then(
        (d) => d.Route,
      ),
    )

const authenticatedPatientsPatientIdVitalsRouteLazyRoute =
  authenticatedPatientsPatientIdVitalsRouteLazyImport
    .update({
      id: '/vitals',
      path: '/vitals',
      getParentRoute: () => authenticatedPatientsPatientIdRouteRoute,
    } as any)
    .lazy(() =>
      import('./routes/(authenticated)/patients/$patientId/vitals/route.lazy').then(
        (d) => d.Route,
      ),
    )

const authenticatedPatientsPatientIdProgramStatusRouteLazyRoute =
  authenticatedPatientsPatientIdProgramStatusRouteLazyImport
    .update({
      id: '/program-status',
      path: '/program-status',
      getParentRoute: () => authenticatedPatientsPatientIdRouteRoute,
    } as any)
    .lazy(() =>
      import('./routes/(authenticated)/patients/$patientId/program-status/route.lazy').then(
        (d) => d.Route,
      ),
    )

const authenticatedPatientsPatientIdProblemsRouteLazyRoute =
  authenticatedPatientsPatientIdProblemsRouteLazyImport
    .update({
      id: '/problems',
      path: '/problems',
      getParentRoute: () => authenticatedPatientsPatientIdRouteRoute,
    } as any)
    .lazy(() =>
      import('./routes/(authenticated)/patients/$patientId/problems/route.lazy').then(
        (d) => d.Route,
      ),
    )

const authenticatedPatientsPatientIdPreventativeQmRouteLazyRoute =
  authenticatedPatientsPatientIdPreventativeQmRouteLazyImport
    .update({
      id: '/preventative-qm',
      path: '/preventative-qm',
      getParentRoute: () => authenticatedPatientsPatientIdRouteRoute,
    } as any)
    .lazy(() =>
      import('./routes/(authenticated)/patients/$patientId/preventative-qm/route.lazy').then(
        (d) => d.Route,
      ),
    )

const authenticatedPatientsPatientIdOutreachRouteLazyRoute =
  authenticatedPatientsPatientIdOutreachRouteLazyImport
    .update({
      id: '/outreach',
      path: '/outreach',
      getParentRoute: () => authenticatedPatientsPatientIdRouteRoute,
    } as any)
    .lazy(() =>
      import('./routes/(authenticated)/patients/$patientId/outreach/route.lazy').then(
        (d) => d.Route,
      ),
    )

const authenticatedPatientsPatientIdNotesRouteLazyRoute =
  authenticatedPatientsPatientIdNotesRouteLazyImport
    .update({
      id: '/notes',
      path: '/notes',
      getParentRoute: () => authenticatedPatientsPatientIdRouteRoute,
    } as any)
    .lazy(() =>
      import('./routes/(authenticated)/patients/$patientId/notes/route.lazy').then(
        (d) => d.Route,
      ),
    )

const authenticatedPatientsPatientIdMedicationsRouteLazyRoute =
  authenticatedPatientsPatientIdMedicationsRouteLazyImport
    .update({
      id: '/medications',
      path: '/medications',
      getParentRoute: () => authenticatedPatientsPatientIdRouteRoute,
    } as any)
    .lazy(() =>
      import('./routes/(authenticated)/patients/$patientId/medications/route.lazy').then(
        (d) => d.Route,
      ),
    )

const authenticatedPatientsPatientIdMedRecRouteLazyRoute =
  authenticatedPatientsPatientIdMedRecRouteLazyImport
    .update({
      id: '/med-rec',
      path: '/med-rec',
      getParentRoute: () => authenticatedPatientsPatientIdRouteRoute,
    } as any)
    .lazy(() =>
      import('./routes/(authenticated)/patients/$patientId/med-rec/route.lazy').then(
        (d) => d.Route,
      ),
    )

const authenticatedPatientsPatientIdLabsRouteLazyRoute =
  authenticatedPatientsPatientIdLabsRouteLazyImport
    .update({
      id: '/labs',
      path: '/labs',
      getParentRoute: () => authenticatedPatientsPatientIdRouteRoute,
    } as any)
    .lazy(() =>
      import('./routes/(authenticated)/patients/$patientId/labs/route.lazy').then(
        (d) => d.Route,
      ),
    )

const authenticatedPatientsPatientIdInsuranceRouteLazyRoute =
  authenticatedPatientsPatientIdInsuranceRouteLazyImport
    .update({
      id: '/insurance',
      path: '/insurance',
      getParentRoute: () => authenticatedPatientsPatientIdRouteRoute,
    } as any)
    .lazy(() =>
      import('./routes/(authenticated)/patients/$patientId/insurance/route.lazy').then(
        (d) => d.Route,
      ),
    )

const authenticatedPatientsPatientIdInpatientRouteLazyRoute =
  authenticatedPatientsPatientIdInpatientRouteLazyImport
    .update({
      id: '/inpatient',
      path: '/inpatient',
      getParentRoute: () => authenticatedPatientsPatientIdRouteRoute,
    } as any)
    .lazy(() =>
      import('./routes/(authenticated)/patients/$patientId/inpatient/route.lazy').then(
        (d) => d.Route,
      ),
    )

const authenticatedPatientsPatientIdDocumentsRouteLazyRoute =
  authenticatedPatientsPatientIdDocumentsRouteLazyImport
    .update({
      id: '/documents',
      path: '/documents',
      getParentRoute: () => authenticatedPatientsPatientIdRouteRoute,
    } as any)
    .lazy(() =>
      import('./routes/(authenticated)/patients/$patientId/documents/route.lazy').then(
        (d) => d.Route,
      ),
    )

const authenticatedPatientsPatientIdDiagnosticsRouteLazyRoute =
  authenticatedPatientsPatientIdDiagnosticsRouteLazyImport
    .update({
      id: '/diagnostics',
      path: '/diagnostics',
      getParentRoute: () => authenticatedPatientsPatientIdRouteRoute,
    } as any)
    .lazy(() =>
      import('./routes/(authenticated)/patients/$patientId/diagnostics/route.lazy').then(
        (d) => d.Route,
      ),
    )

const authenticatedPatientsPatientIdDemographicsRouteLazyRoute =
  authenticatedPatientsPatientIdDemographicsRouteLazyImport
    .update({
      id: '/demographics',
      path: '/demographics',
      getParentRoute: () => authenticatedPatientsPatientIdRouteRoute,
    } as any)
    .lazy(() =>
      import('./routes/(authenticated)/patients/$patientId/demographics/route.lazy').then(
        (d) => d.Route,
      ),
    )

const authenticatedPatientsPatientIdCommunicationsRouteLazyRoute =
  authenticatedPatientsPatientIdCommunicationsRouteLazyImport
    .update({
      id: '/communications',
      path: '/communications',
      getParentRoute: () => authenticatedPatientsPatientIdRouteRoute,
    } as any)
    .lazy(() =>
      import('./routes/(authenticated)/patients/$patientId/communications/route.lazy').then(
        (d) => d.Route,
      ),
    )

const authenticatedPatientsPatientIdCareTeamRouteLazyRoute =
  authenticatedPatientsPatientIdCareTeamRouteLazyImport
    .update({
      id: '/care-team',
      path: '/care-team',
      getParentRoute: () => authenticatedPatientsPatientIdRouteRoute,
    } as any)
    .lazy(() =>
      import('./routes/(authenticated)/patients/$patientId/care-team/route.lazy').then(
        (d) => d.Route,
      ),
    )

const authenticatedPatientsPatientIdCareCallRouteLazyRoute =
  authenticatedPatientsPatientIdCareCallRouteLazyImport
    .update({
      id: '/care-call',
      path: '/care-call',
      getParentRoute: () => authenticatedPatientsPatientIdRouteRoute,
    } as any)
    .lazy(() =>
      import('./routes/(authenticated)/patients/$patientId/care-call/route.lazy').then(
        (d) => d.Route,
      ),
    )

const authenticatedPatientsPatientIdAssessmentsRouteLazyRoute =
  authenticatedPatientsPatientIdAssessmentsRouteLazyImport
    .update({
      id: '/assessments',
      path: '/assessments',
      getParentRoute: () => authenticatedPatientsPatientIdRouteRoute,
    } as any)
    .lazy(() =>
      import('./routes/(authenticated)/patients/$patientId/assessments/route.lazy').then(
        (d) => d.Route,
      ),
    )

const authenticatedPatientsPatientIdAppointmentsRouteLazyRoute =
  authenticatedPatientsPatientIdAppointmentsRouteLazyImport
    .update({
      id: '/appointments',
      path: '/appointments',
      getParentRoute: () => authenticatedPatientsPatientIdRouteRoute,
    } as any)
    .lazy(() =>
      import('./routes/(authenticated)/patients/$patientId/appointments/route.lazy').then(
        (d) => d.Route,
      ),
    )

const authenticatedPatientsPatientIdAllergiesRouteLazyRoute =
  authenticatedPatientsPatientIdAllergiesRouteLazyImport
    .update({
      id: '/allergies',
      path: '/allergies',
      getParentRoute: () => authenticatedPatientsPatientIdRouteRoute,
    } as any)
    .lazy(() =>
      import('./routes/(authenticated)/patients/$patientId/allergies/route.lazy').then(
        (d) => d.Route,
      ),
    )

const authenticatedPatientsPatientIdAdvanceDirectivesRouteLazyRoute =
  authenticatedPatientsPatientIdAdvanceDirectivesRouteLazyImport
    .update({
      id: '/advance-directives',
      path: '/advance-directives',
      getParentRoute: () => authenticatedPatientsPatientIdRouteRoute,
    } as any)
    .lazy(() =>
      import('./routes/(authenticated)/patients/$patientId/advance-directives/route.lazy').then(
        (d) => d.Route,
      ),
    )

const authenticatedUsersUserIdIndexRouteLazyRoute =
  authenticatedUsersUserIdIndexRouteLazyImport
    .update({
      id: '/',
      path: '/',
      getParentRoute: () => authenticatedUsersUserIdRouteLazyRoute,
    } as any)
    .lazy(() =>
      import('./routes/(authenticated)/users/$userId/index/route.lazy').then(
        (d) => d.Route,
      ),
    )

const authenticatedReferralsNewIndexRouteLazyRoute =
  authenticatedReferralsNewIndexRouteLazyImport
    .update({
      id: '/',
      path: '/',
      getParentRoute: () => authenticatedReferralsNewRouteLazyRoute,
    } as any)
    .lazy(() =>
      import('./routes/(authenticated)/referrals/new/index/route.lazy').then(
        (d) => d.Route,
      ),
    )

const authenticatedPatientsPatientIdPhysicianSummaryRouteRoute =
  authenticatedPatientsPatientIdPhysicianSummaryRouteImport
    .update({
      id: '/physician-summary',
      path: '/physician-summary',
      getParentRoute: () => authenticatedPatientsPatientIdRouteRoute,
    } as any)
    .lazy(() =>
      import('./routes/(authenticated)/patients/$patientId/physician-summary/route.lazy').then(
        (d) => d.Route,
      ),
    )

const authenticatedPatientsPatientIdMonthlyCareLogRouteRoute =
  authenticatedPatientsPatientIdMonthlyCareLogRouteImport
    .update({
      id: '/monthly-care-log',
      path: '/monthly-care-log',
      getParentRoute: () => authenticatedPatientsPatientIdRouteRoute,
    } as any)
    .lazy(() =>
      import('./routes/(authenticated)/patients/$patientId/monthly-care-log/route.lazy').then(
        (d) => d.Route,
      ),
    )

const authenticatedPatientsPatientIdCarePlanRouteRoute =
  authenticatedPatientsPatientIdCarePlanRouteImport
    .update({
      id: '/care-plan',
      path: '/care-plan',
      getParentRoute: () => authenticatedPatientsPatientIdRouteRoute,
    } as any)
    .lazy(() =>
      import('./routes/(authenticated)/patients/$patientId/care-plan/route.lazy').then(
        (d) => d.Route,
      ),
    )

const authenticatedPatientsPatientIdIndexRouteRoute =
  authenticatedPatientsPatientIdIndexRouteImport
    .update({
      id: '/',
      path: '/',
      getParentRoute: () => authenticatedPatientsPatientIdRouteRoute,
    } as any)
    .lazy(() =>
      import('./routes/(authenticated)/patients/$patientId/index/route.lazy').then(
        (d) => d.Route,
      ),
    )

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof RouteImport
      parentRoute: typeof rootRoute
    }
    '/(authenticated)': {
      id: '/(authenticated)'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof authenticatedRouteImport
      parentRoute: typeof rootRoute
    }
    '/(authenticated)/dashboard': {
      id: '/(authenticated)/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof authenticatedDashboardRouteImport
      parentRoute: typeof authenticatedRouteImport
    }
    '/(authenticated)/referrals': {
      id: '/(authenticated)/referrals'
      path: '/referrals'
      fullPath: '/referrals'
      preLoaderRoute: typeof authenticatedReferralsRouteImport
      parentRoute: typeof authenticatedRouteImport
    }
    '/(unauthenticated)/sign-out': {
      id: '/(unauthenticated)/sign-out'
      path: '/sign-out'
      fullPath: '/sign-out'
      preLoaderRoute: typeof unauthenticatedSignOutRouteImport
      parentRoute: typeof rootRoute
    }
    '/(authenticated)/assessments': {
      id: '/(authenticated)/assessments'
      path: '/assessments'
      fullPath: '/assessments'
      preLoaderRoute: typeof authenticatedAssessmentsRouteLazyImport
      parentRoute: typeof authenticatedRouteImport
    }
    '/(authenticated)/entities': {
      id: '/(authenticated)/entities'
      path: '/entities'
      fullPath: '/entities'
      preLoaderRoute: typeof authenticatedEntitiesRouteLazyImport
      parentRoute: typeof authenticatedRouteImport
    }
    '/(authenticated)/messages': {
      id: '/(authenticated)/messages'
      path: '/messages'
      fullPath: '/messages'
      preLoaderRoute: typeof authenticatedMessagesRouteLazyImport
      parentRoute: typeof authenticatedRouteImport
    }
    '/(authenticated)/patients': {
      id: '/(authenticated)/patients'
      path: '/patients'
      fullPath: '/patients'
      preLoaderRoute: typeof authenticatedPatientsRouteLazyImport
      parentRoute: typeof authenticatedRouteImport
    }
    '/(authenticated)/users': {
      id: '/(authenticated)/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof authenticatedUsersRouteLazyImport
      parentRoute: typeof authenticatedRouteImport
    }
    '/(unauthenticated)/forgot-password': {
      id: '/(unauthenticated)/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof unauthenticatedForgotPasswordRouteLazyImport
      parentRoute: typeof rootRoute
    }
    '/(authenticated)/entities/': {
      id: '/(authenticated)/entities/'
      path: '/'
      fullPath: '/entities/'
      preLoaderRoute: typeof authenticatedEntitiesIndexRouteImport
      parentRoute: typeof authenticatedEntitiesRouteLazyImport
    }
    '/(authenticated)/patients/': {
      id: '/(authenticated)/patients/'
      path: '/'
      fullPath: '/patients/'
      preLoaderRoute: typeof authenticatedPatientsIndexRouteImport
      parentRoute: typeof authenticatedPatientsRouteLazyImport
    }
    '/(authenticated)/users/': {
      id: '/(authenticated)/users/'
      path: '/'
      fullPath: '/users/'
      preLoaderRoute: typeof authenticatedUsersIndexRouteImport
      parentRoute: typeof authenticatedUsersRouteLazyImport
    }
    '/(authenticated)/assessments/$id': {
      id: '/(authenticated)/assessments/$id'
      path: '/$id'
      fullPath: '/assessments/$id'
      preLoaderRoute: typeof authenticatedAssessmentsIdRouteImport
      parentRoute: typeof authenticatedAssessmentsRouteLazyImport
    }
    '/(authenticated)/entities/$entityId': {
      id: '/(authenticated)/entities/$entityId'
      path: '/$entityId'
      fullPath: '/entities/$entityId'
      preLoaderRoute: typeof authenticatedEntitiesEntityIdRouteImport
      parentRoute: typeof authenticatedEntitiesRouteLazyImport
    }
    '/(authenticated)/patients/$patientId': {
      id: '/(authenticated)/patients/$patientId'
      path: '/$patientId'
      fullPath: '/patients/$patientId'
      preLoaderRoute: typeof authenticatedPatientsPatientIdRouteImport
      parentRoute: typeof authenticatedPatientsRouteLazyImport
    }
    '/(authenticated)/referrals/$id': {
      id: '/(authenticated)/referrals/$id'
      path: '/$id'
      fullPath: '/referrals/$id'
      preLoaderRoute: typeof authenticatedReferralsIdRouteImport
      parentRoute: typeof authenticatedReferralsRouteImport
    }
    '/(authenticated)/assessments/': {
      id: '/(authenticated)/assessments/'
      path: '/'
      fullPath: '/assessments/'
      preLoaderRoute: typeof authenticatedAssessmentsIndexRouteLazyImport
      parentRoute: typeof authenticatedAssessmentsRouteLazyImport
    }
    '/(authenticated)/referrals/': {
      id: '/(authenticated)/referrals/'
      path: '/'
      fullPath: '/referrals/'
      preLoaderRoute: typeof authenticatedReferralsIndexRouteLazyImport
      parentRoute: typeof authenticatedReferralsRouteImport
    }
    '/(authenticated)/assessments/new': {
      id: '/(authenticated)/assessments/new'
      path: '/new'
      fullPath: '/assessments/new'
      preLoaderRoute: typeof authenticatedAssessmentsNewRouteLazyImport
      parentRoute: typeof authenticatedAssessmentsRouteLazyImport
    }
    '/(authenticated)/patients/new': {
      id: '/(authenticated)/patients/new'
      path: '/new'
      fullPath: '/patients/new'
      preLoaderRoute: typeof authenticatedPatientsNewRouteLazyImport
      parentRoute: typeof authenticatedPatientsRouteLazyImport
    }
    '/(authenticated)/referrals/new': {
      id: '/(authenticated)/referrals/new'
      path: '/new'
      fullPath: '/referrals/new'
      preLoaderRoute: typeof authenticatedReferralsNewRouteLazyImport
      parentRoute: typeof authenticatedReferralsRouteImport
    }
    '/(authenticated)/users/$userId': {
      id: '/(authenticated)/users/$userId'
      path: '/$userId'
      fullPath: '/users/$userId'
      preLoaderRoute: typeof authenticatedUsersUserIdRouteLazyImport
      parentRoute: typeof authenticatedUsersRouteLazyImport
    }
    '/(authenticated)/users/new': {
      id: '/(authenticated)/users/new'
      path: '/new'
      fullPath: '/users/new'
      preLoaderRoute: typeof authenticatedUsersNewRouteLazyImport
      parentRoute: typeof authenticatedUsersRouteLazyImport
    }
    '/(authenticated)/patients/$patientId/': {
      id: '/(authenticated)/patients/$patientId/'
      path: '/'
      fullPath: '/patients/$patientId/'
      preLoaderRoute: typeof authenticatedPatientsPatientIdIndexRouteImport
      parentRoute: typeof authenticatedPatientsPatientIdRouteImport
    }
    '/(authenticated)/patients/$patientId/care-plan': {
      id: '/(authenticated)/patients/$patientId/care-plan'
      path: '/care-plan'
      fullPath: '/patients/$patientId/care-plan'
      preLoaderRoute: typeof authenticatedPatientsPatientIdCarePlanRouteImport
      parentRoute: typeof authenticatedPatientsPatientIdRouteImport
    }
    '/(authenticated)/patients/$patientId/monthly-care-log': {
      id: '/(authenticated)/patients/$patientId/monthly-care-log'
      path: '/monthly-care-log'
      fullPath: '/patients/$patientId/monthly-care-log'
      preLoaderRoute: typeof authenticatedPatientsPatientIdMonthlyCareLogRouteImport
      parentRoute: typeof authenticatedPatientsPatientIdRouteImport
    }
    '/(authenticated)/patients/$patientId/physician-summary': {
      id: '/(authenticated)/patients/$patientId/physician-summary'
      path: '/physician-summary'
      fullPath: '/patients/$patientId/physician-summary'
      preLoaderRoute: typeof authenticatedPatientsPatientIdPhysicianSummaryRouteImport
      parentRoute: typeof authenticatedPatientsPatientIdRouteImport
    }
    '/(authenticated)/referrals/new/': {
      id: '/(authenticated)/referrals/new/'
      path: '/'
      fullPath: '/referrals/new/'
      preLoaderRoute: typeof authenticatedReferralsNewIndexRouteLazyImport
      parentRoute: typeof authenticatedReferralsNewRouteLazyImport
    }
    '/(authenticated)/users/$userId/': {
      id: '/(authenticated)/users/$userId/'
      path: '/'
      fullPath: '/users/$userId/'
      preLoaderRoute: typeof authenticatedUsersUserIdIndexRouteLazyImport
      parentRoute: typeof authenticatedUsersUserIdRouteLazyImport
    }
    '/(authenticated)/patients/$patientId/advance-directives': {
      id: '/(authenticated)/patients/$patientId/advance-directives'
      path: '/advance-directives'
      fullPath: '/patients/$patientId/advance-directives'
      preLoaderRoute: typeof authenticatedPatientsPatientIdAdvanceDirectivesRouteLazyImport
      parentRoute: typeof authenticatedPatientsPatientIdRouteImport
    }
    '/(authenticated)/patients/$patientId/allergies': {
      id: '/(authenticated)/patients/$patientId/allergies'
      path: '/allergies'
      fullPath: '/patients/$patientId/allergies'
      preLoaderRoute: typeof authenticatedPatientsPatientIdAllergiesRouteLazyImport
      parentRoute: typeof authenticatedPatientsPatientIdRouteImport
    }
    '/(authenticated)/patients/$patientId/appointments': {
      id: '/(authenticated)/patients/$patientId/appointments'
      path: '/appointments'
      fullPath: '/patients/$patientId/appointments'
      preLoaderRoute: typeof authenticatedPatientsPatientIdAppointmentsRouteLazyImport
      parentRoute: typeof authenticatedPatientsPatientIdRouteImport
    }
    '/(authenticated)/patients/$patientId/assessments': {
      id: '/(authenticated)/patients/$patientId/assessments'
      path: '/assessments'
      fullPath: '/patients/$patientId/assessments'
      preLoaderRoute: typeof authenticatedPatientsPatientIdAssessmentsRouteLazyImport
      parentRoute: typeof authenticatedPatientsPatientIdRouteImport
    }
    '/(authenticated)/patients/$patientId/care-call': {
      id: '/(authenticated)/patients/$patientId/care-call'
      path: '/care-call'
      fullPath: '/patients/$patientId/care-call'
      preLoaderRoute: typeof authenticatedPatientsPatientIdCareCallRouteLazyImport
      parentRoute: typeof authenticatedPatientsPatientIdRouteImport
    }
    '/(authenticated)/patients/$patientId/care-team': {
      id: '/(authenticated)/patients/$patientId/care-team'
      path: '/care-team'
      fullPath: '/patients/$patientId/care-team'
      preLoaderRoute: typeof authenticatedPatientsPatientIdCareTeamRouteLazyImport
      parentRoute: typeof authenticatedPatientsPatientIdRouteImport
    }
    '/(authenticated)/patients/$patientId/communications': {
      id: '/(authenticated)/patients/$patientId/communications'
      path: '/communications'
      fullPath: '/patients/$patientId/communications'
      preLoaderRoute: typeof authenticatedPatientsPatientIdCommunicationsRouteLazyImport
      parentRoute: typeof authenticatedPatientsPatientIdRouteImport
    }
    '/(authenticated)/patients/$patientId/demographics': {
      id: '/(authenticated)/patients/$patientId/demographics'
      path: '/demographics'
      fullPath: '/patients/$patientId/demographics'
      preLoaderRoute: typeof authenticatedPatientsPatientIdDemographicsRouteLazyImport
      parentRoute: typeof authenticatedPatientsPatientIdRouteImport
    }
    '/(authenticated)/patients/$patientId/diagnostics': {
      id: '/(authenticated)/patients/$patientId/diagnostics'
      path: '/diagnostics'
      fullPath: '/patients/$patientId/diagnostics'
      preLoaderRoute: typeof authenticatedPatientsPatientIdDiagnosticsRouteLazyImport
      parentRoute: typeof authenticatedPatientsPatientIdRouteImport
    }
    '/(authenticated)/patients/$patientId/documents': {
      id: '/(authenticated)/patients/$patientId/documents'
      path: '/documents'
      fullPath: '/patients/$patientId/documents'
      preLoaderRoute: typeof authenticatedPatientsPatientIdDocumentsRouteLazyImport
      parentRoute: typeof authenticatedPatientsPatientIdRouteImport
    }
    '/(authenticated)/patients/$patientId/inpatient': {
      id: '/(authenticated)/patients/$patientId/inpatient'
      path: '/inpatient'
      fullPath: '/patients/$patientId/inpatient'
      preLoaderRoute: typeof authenticatedPatientsPatientIdInpatientRouteLazyImport
      parentRoute: typeof authenticatedPatientsPatientIdRouteImport
    }
    '/(authenticated)/patients/$patientId/insurance': {
      id: '/(authenticated)/patients/$patientId/insurance'
      path: '/insurance'
      fullPath: '/patients/$patientId/insurance'
      preLoaderRoute: typeof authenticatedPatientsPatientIdInsuranceRouteLazyImport
      parentRoute: typeof authenticatedPatientsPatientIdRouteImport
    }
    '/(authenticated)/patients/$patientId/labs': {
      id: '/(authenticated)/patients/$patientId/labs'
      path: '/labs'
      fullPath: '/patients/$patientId/labs'
      preLoaderRoute: typeof authenticatedPatientsPatientIdLabsRouteLazyImport
      parentRoute: typeof authenticatedPatientsPatientIdRouteImport
    }
    '/(authenticated)/patients/$patientId/med-rec': {
      id: '/(authenticated)/patients/$patientId/med-rec'
      path: '/med-rec'
      fullPath: '/patients/$patientId/med-rec'
      preLoaderRoute: typeof authenticatedPatientsPatientIdMedRecRouteLazyImport
      parentRoute: typeof authenticatedPatientsPatientIdRouteImport
    }
    '/(authenticated)/patients/$patientId/medications': {
      id: '/(authenticated)/patients/$patientId/medications'
      path: '/medications'
      fullPath: '/patients/$patientId/medications'
      preLoaderRoute: typeof authenticatedPatientsPatientIdMedicationsRouteLazyImport
      parentRoute: typeof authenticatedPatientsPatientIdRouteImport
    }
    '/(authenticated)/patients/$patientId/notes': {
      id: '/(authenticated)/patients/$patientId/notes'
      path: '/notes'
      fullPath: '/patients/$patientId/notes'
      preLoaderRoute: typeof authenticatedPatientsPatientIdNotesRouteLazyImport
      parentRoute: typeof authenticatedPatientsPatientIdRouteImport
    }
    '/(authenticated)/patients/$patientId/outreach': {
      id: '/(authenticated)/patients/$patientId/outreach'
      path: '/outreach'
      fullPath: '/patients/$patientId/outreach'
      preLoaderRoute: typeof authenticatedPatientsPatientIdOutreachRouteLazyImport
      parentRoute: typeof authenticatedPatientsPatientIdRouteImport
    }
    '/(authenticated)/patients/$patientId/preventative-qm': {
      id: '/(authenticated)/patients/$patientId/preventative-qm'
      path: '/preventative-qm'
      fullPath: '/patients/$patientId/preventative-qm'
      preLoaderRoute: typeof authenticatedPatientsPatientIdPreventativeQmRouteLazyImport
      parentRoute: typeof authenticatedPatientsPatientIdRouteImport
    }
    '/(authenticated)/patients/$patientId/problems': {
      id: '/(authenticated)/patients/$patientId/problems'
      path: '/problems'
      fullPath: '/patients/$patientId/problems'
      preLoaderRoute: typeof authenticatedPatientsPatientIdProblemsRouteLazyImport
      parentRoute: typeof authenticatedPatientsPatientIdRouteImport
    }
    '/(authenticated)/patients/$patientId/program-status': {
      id: '/(authenticated)/patients/$patientId/program-status'
      path: '/program-status'
      fullPath: '/patients/$patientId/program-status'
      preLoaderRoute: typeof authenticatedPatientsPatientIdProgramStatusRouteLazyImport
      parentRoute: typeof authenticatedPatientsPatientIdRouteImport
    }
    '/(authenticated)/patients/$patientId/vitals': {
      id: '/(authenticated)/patients/$patientId/vitals'
      path: '/vitals'
      fullPath: '/patients/$patientId/vitals'
      preLoaderRoute: typeof authenticatedPatientsPatientIdVitalsRouteLazyImport
      parentRoute: typeof authenticatedPatientsPatientIdRouteImport
    }
    '/(authenticated)/referrals/new/import': {
      id: '/(authenticated)/referrals/new/import'
      path: '/import'
      fullPath: '/referrals/new/import'
      preLoaderRoute: typeof authenticatedReferralsNewImportRouteLazyImport
      parentRoute: typeof authenticatedReferralsNewRouteLazyImport
    }
    '/(authenticated)/referrals/new/pdf-import': {
      id: '/(authenticated)/referrals/new/pdf-import'
      path: '/pdf-import'
      fullPath: '/referrals/new/pdf-import'
      preLoaderRoute: typeof authenticatedReferralsNewPdfImportRouteLazyImport
      parentRoute: typeof authenticatedReferralsNewRouteLazyImport
    }
  }
}

// Create and export the route tree

interface authenticatedReferralsNewRouteLazyRouteChildren {
  authenticatedReferralsNewIndexRouteLazyRoute: typeof authenticatedReferralsNewIndexRouteLazyRoute
  authenticatedReferralsNewImportRouteLazyRoute: typeof authenticatedReferralsNewImportRouteLazyRoute
  authenticatedReferralsNewPdfImportRouteLazyRoute: typeof authenticatedReferralsNewPdfImportRouteLazyRoute
}

const authenticatedReferralsNewRouteLazyRouteChildren: authenticatedReferralsNewRouteLazyRouteChildren =
  {
    authenticatedReferralsNewIndexRouteLazyRoute:
      authenticatedReferralsNewIndexRouteLazyRoute,
    authenticatedReferralsNewImportRouteLazyRoute:
      authenticatedReferralsNewImportRouteLazyRoute,
    authenticatedReferralsNewPdfImportRouteLazyRoute:
      authenticatedReferralsNewPdfImportRouteLazyRoute,
  }

const authenticatedReferralsNewRouteLazyRouteWithChildren =
  authenticatedReferralsNewRouteLazyRoute._addFileChildren(
    authenticatedReferralsNewRouteLazyRouteChildren,
  )

interface authenticatedReferralsRouteRouteChildren {
  authenticatedReferralsIdRouteRoute: typeof authenticatedReferralsIdRouteRoute
  authenticatedReferralsIndexRouteLazyRoute: typeof authenticatedReferralsIndexRouteLazyRoute
  authenticatedReferralsNewRouteLazyRoute: typeof authenticatedReferralsNewRouteLazyRouteWithChildren
}

const authenticatedReferralsRouteRouteChildren: authenticatedReferralsRouteRouteChildren =
  {
    authenticatedReferralsIdRouteRoute: authenticatedReferralsIdRouteRoute,
    authenticatedReferralsIndexRouteLazyRoute:
      authenticatedReferralsIndexRouteLazyRoute,
    authenticatedReferralsNewRouteLazyRoute:
      authenticatedReferralsNewRouteLazyRouteWithChildren,
  }

const authenticatedReferralsRouteRouteWithChildren =
  authenticatedReferralsRouteRoute._addFileChildren(
    authenticatedReferralsRouteRouteChildren,
  )

interface authenticatedAssessmentsRouteLazyRouteChildren {
  authenticatedAssessmentsIdRouteRoute: typeof authenticatedAssessmentsIdRouteRoute
  authenticatedAssessmentsIndexRouteLazyRoute: typeof authenticatedAssessmentsIndexRouteLazyRoute
  authenticatedAssessmentsNewRouteLazyRoute: typeof authenticatedAssessmentsNewRouteLazyRoute
}

const authenticatedAssessmentsRouteLazyRouteChildren: authenticatedAssessmentsRouteLazyRouteChildren =
  {
    authenticatedAssessmentsIdRouteRoute: authenticatedAssessmentsIdRouteRoute,
    authenticatedAssessmentsIndexRouteLazyRoute:
      authenticatedAssessmentsIndexRouteLazyRoute,
    authenticatedAssessmentsNewRouteLazyRoute:
      authenticatedAssessmentsNewRouteLazyRoute,
  }

const authenticatedAssessmentsRouteLazyRouteWithChildren =
  authenticatedAssessmentsRouteLazyRoute._addFileChildren(
    authenticatedAssessmentsRouteLazyRouteChildren,
  )

interface authenticatedEntitiesRouteLazyRouteChildren {
  authenticatedEntitiesIndexRouteRoute: typeof authenticatedEntitiesIndexRouteRoute
  authenticatedEntitiesEntityIdRouteRoute: typeof authenticatedEntitiesEntityIdRouteRoute
}

const authenticatedEntitiesRouteLazyRouteChildren: authenticatedEntitiesRouteLazyRouteChildren =
  {
    authenticatedEntitiesIndexRouteRoute: authenticatedEntitiesIndexRouteRoute,
    authenticatedEntitiesEntityIdRouteRoute:
      authenticatedEntitiesEntityIdRouteRoute,
  }

const authenticatedEntitiesRouteLazyRouteWithChildren =
  authenticatedEntitiesRouteLazyRoute._addFileChildren(
    authenticatedEntitiesRouteLazyRouteChildren,
  )

interface authenticatedPatientsPatientIdRouteRouteChildren {
  authenticatedPatientsPatientIdIndexRouteRoute: typeof authenticatedPatientsPatientIdIndexRouteRoute
  authenticatedPatientsPatientIdCarePlanRouteRoute: typeof authenticatedPatientsPatientIdCarePlanRouteRoute
  authenticatedPatientsPatientIdMonthlyCareLogRouteRoute: typeof authenticatedPatientsPatientIdMonthlyCareLogRouteRoute
  authenticatedPatientsPatientIdPhysicianSummaryRouteRoute: typeof authenticatedPatientsPatientIdPhysicianSummaryRouteRoute
  authenticatedPatientsPatientIdAdvanceDirectivesRouteLazyRoute: typeof authenticatedPatientsPatientIdAdvanceDirectivesRouteLazyRoute
  authenticatedPatientsPatientIdAllergiesRouteLazyRoute: typeof authenticatedPatientsPatientIdAllergiesRouteLazyRoute
  authenticatedPatientsPatientIdAppointmentsRouteLazyRoute: typeof authenticatedPatientsPatientIdAppointmentsRouteLazyRoute
  authenticatedPatientsPatientIdAssessmentsRouteLazyRoute: typeof authenticatedPatientsPatientIdAssessmentsRouteLazyRoute
  authenticatedPatientsPatientIdCareCallRouteLazyRoute: typeof authenticatedPatientsPatientIdCareCallRouteLazyRoute
  authenticatedPatientsPatientIdCareTeamRouteLazyRoute: typeof authenticatedPatientsPatientIdCareTeamRouteLazyRoute
  authenticatedPatientsPatientIdCommunicationsRouteLazyRoute: typeof authenticatedPatientsPatientIdCommunicationsRouteLazyRoute
  authenticatedPatientsPatientIdDemographicsRouteLazyRoute: typeof authenticatedPatientsPatientIdDemographicsRouteLazyRoute
  authenticatedPatientsPatientIdDiagnosticsRouteLazyRoute: typeof authenticatedPatientsPatientIdDiagnosticsRouteLazyRoute
  authenticatedPatientsPatientIdDocumentsRouteLazyRoute: typeof authenticatedPatientsPatientIdDocumentsRouteLazyRoute
  authenticatedPatientsPatientIdInpatientRouteLazyRoute: typeof authenticatedPatientsPatientIdInpatientRouteLazyRoute
  authenticatedPatientsPatientIdInsuranceRouteLazyRoute: typeof authenticatedPatientsPatientIdInsuranceRouteLazyRoute
  authenticatedPatientsPatientIdLabsRouteLazyRoute: typeof authenticatedPatientsPatientIdLabsRouteLazyRoute
  authenticatedPatientsPatientIdMedRecRouteLazyRoute: typeof authenticatedPatientsPatientIdMedRecRouteLazyRoute
  authenticatedPatientsPatientIdMedicationsRouteLazyRoute: typeof authenticatedPatientsPatientIdMedicationsRouteLazyRoute
  authenticatedPatientsPatientIdNotesRouteLazyRoute: typeof authenticatedPatientsPatientIdNotesRouteLazyRoute
  authenticatedPatientsPatientIdOutreachRouteLazyRoute: typeof authenticatedPatientsPatientIdOutreachRouteLazyRoute
  authenticatedPatientsPatientIdPreventativeQmRouteLazyRoute: typeof authenticatedPatientsPatientIdPreventativeQmRouteLazyRoute
  authenticatedPatientsPatientIdProblemsRouteLazyRoute: typeof authenticatedPatientsPatientIdProblemsRouteLazyRoute
  authenticatedPatientsPatientIdProgramStatusRouteLazyRoute: typeof authenticatedPatientsPatientIdProgramStatusRouteLazyRoute
  authenticatedPatientsPatientIdVitalsRouteLazyRoute: typeof authenticatedPatientsPatientIdVitalsRouteLazyRoute
}

const authenticatedPatientsPatientIdRouteRouteChildren: authenticatedPatientsPatientIdRouteRouteChildren =
  {
    authenticatedPatientsPatientIdIndexRouteRoute:
      authenticatedPatientsPatientIdIndexRouteRoute,
    authenticatedPatientsPatientIdCarePlanRouteRoute:
      authenticatedPatientsPatientIdCarePlanRouteRoute,
    authenticatedPatientsPatientIdMonthlyCareLogRouteRoute:
      authenticatedPatientsPatientIdMonthlyCareLogRouteRoute,
    authenticatedPatientsPatientIdPhysicianSummaryRouteRoute:
      authenticatedPatientsPatientIdPhysicianSummaryRouteRoute,
    authenticatedPatientsPatientIdAdvanceDirectivesRouteLazyRoute:
      authenticatedPatientsPatientIdAdvanceDirectivesRouteLazyRoute,
    authenticatedPatientsPatientIdAllergiesRouteLazyRoute:
      authenticatedPatientsPatientIdAllergiesRouteLazyRoute,
    authenticatedPatientsPatientIdAppointmentsRouteLazyRoute:
      authenticatedPatientsPatientIdAppointmentsRouteLazyRoute,
    authenticatedPatientsPatientIdAssessmentsRouteLazyRoute:
      authenticatedPatientsPatientIdAssessmentsRouteLazyRoute,
    authenticatedPatientsPatientIdCareCallRouteLazyRoute:
      authenticatedPatientsPatientIdCareCallRouteLazyRoute,
    authenticatedPatientsPatientIdCareTeamRouteLazyRoute:
      authenticatedPatientsPatientIdCareTeamRouteLazyRoute,
    authenticatedPatientsPatientIdCommunicationsRouteLazyRoute:
      authenticatedPatientsPatientIdCommunicationsRouteLazyRoute,
    authenticatedPatientsPatientIdDemographicsRouteLazyRoute:
      authenticatedPatientsPatientIdDemographicsRouteLazyRoute,
    authenticatedPatientsPatientIdDiagnosticsRouteLazyRoute:
      authenticatedPatientsPatientIdDiagnosticsRouteLazyRoute,
    authenticatedPatientsPatientIdDocumentsRouteLazyRoute:
      authenticatedPatientsPatientIdDocumentsRouteLazyRoute,
    authenticatedPatientsPatientIdInpatientRouteLazyRoute:
      authenticatedPatientsPatientIdInpatientRouteLazyRoute,
    authenticatedPatientsPatientIdInsuranceRouteLazyRoute:
      authenticatedPatientsPatientIdInsuranceRouteLazyRoute,
    authenticatedPatientsPatientIdLabsRouteLazyRoute:
      authenticatedPatientsPatientIdLabsRouteLazyRoute,
    authenticatedPatientsPatientIdMedRecRouteLazyRoute:
      authenticatedPatientsPatientIdMedRecRouteLazyRoute,
    authenticatedPatientsPatientIdMedicationsRouteLazyRoute:
      authenticatedPatientsPatientIdMedicationsRouteLazyRoute,
    authenticatedPatientsPatientIdNotesRouteLazyRoute:
      authenticatedPatientsPatientIdNotesRouteLazyRoute,
    authenticatedPatientsPatientIdOutreachRouteLazyRoute:
      authenticatedPatientsPatientIdOutreachRouteLazyRoute,
    authenticatedPatientsPatientIdPreventativeQmRouteLazyRoute:
      authenticatedPatientsPatientIdPreventativeQmRouteLazyRoute,
    authenticatedPatientsPatientIdProblemsRouteLazyRoute:
      authenticatedPatientsPatientIdProblemsRouteLazyRoute,
    authenticatedPatientsPatientIdProgramStatusRouteLazyRoute:
      authenticatedPatientsPatientIdProgramStatusRouteLazyRoute,
    authenticatedPatientsPatientIdVitalsRouteLazyRoute:
      authenticatedPatientsPatientIdVitalsRouteLazyRoute,
  }

const authenticatedPatientsPatientIdRouteRouteWithChildren =
  authenticatedPatientsPatientIdRouteRoute._addFileChildren(
    authenticatedPatientsPatientIdRouteRouteChildren,
  )

interface authenticatedPatientsRouteLazyRouteChildren {
  authenticatedPatientsIndexRouteRoute: typeof authenticatedPatientsIndexRouteRoute
  authenticatedPatientsPatientIdRouteRoute: typeof authenticatedPatientsPatientIdRouteRouteWithChildren
  authenticatedPatientsNewRouteLazyRoute: typeof authenticatedPatientsNewRouteLazyRoute
}

const authenticatedPatientsRouteLazyRouteChildren: authenticatedPatientsRouteLazyRouteChildren =
  {
    authenticatedPatientsIndexRouteRoute: authenticatedPatientsIndexRouteRoute,
    authenticatedPatientsPatientIdRouteRoute:
      authenticatedPatientsPatientIdRouteRouteWithChildren,
    authenticatedPatientsNewRouteLazyRoute:
      authenticatedPatientsNewRouteLazyRoute,
  }

const authenticatedPatientsRouteLazyRouteWithChildren =
  authenticatedPatientsRouteLazyRoute._addFileChildren(
    authenticatedPatientsRouteLazyRouteChildren,
  )

interface authenticatedUsersUserIdRouteLazyRouteChildren {
  authenticatedUsersUserIdIndexRouteLazyRoute: typeof authenticatedUsersUserIdIndexRouteLazyRoute
}

const authenticatedUsersUserIdRouteLazyRouteChildren: authenticatedUsersUserIdRouteLazyRouteChildren =
  {
    authenticatedUsersUserIdIndexRouteLazyRoute:
      authenticatedUsersUserIdIndexRouteLazyRoute,
  }

const authenticatedUsersUserIdRouteLazyRouteWithChildren =
  authenticatedUsersUserIdRouteLazyRoute._addFileChildren(
    authenticatedUsersUserIdRouteLazyRouteChildren,
  )

interface authenticatedUsersRouteLazyRouteChildren {
  authenticatedUsersIndexRouteRoute: typeof authenticatedUsersIndexRouteRoute
  authenticatedUsersUserIdRouteLazyRoute: typeof authenticatedUsersUserIdRouteLazyRouteWithChildren
  authenticatedUsersNewRouteLazyRoute: typeof authenticatedUsersNewRouteLazyRoute
}

const authenticatedUsersRouteLazyRouteChildren: authenticatedUsersRouteLazyRouteChildren =
  {
    authenticatedUsersIndexRouteRoute: authenticatedUsersIndexRouteRoute,
    authenticatedUsersUserIdRouteLazyRoute:
      authenticatedUsersUserIdRouteLazyRouteWithChildren,
    authenticatedUsersNewRouteLazyRoute: authenticatedUsersNewRouteLazyRoute,
  }

const authenticatedUsersRouteLazyRouteWithChildren =
  authenticatedUsersRouteLazyRoute._addFileChildren(
    authenticatedUsersRouteLazyRouteChildren,
  )

interface authenticatedRouteRouteChildren {
  authenticatedDashboardRouteRoute: typeof authenticatedDashboardRouteRoute
  authenticatedReferralsRouteRoute: typeof authenticatedReferralsRouteRouteWithChildren
  authenticatedAssessmentsRouteLazyRoute: typeof authenticatedAssessmentsRouteLazyRouteWithChildren
  authenticatedEntitiesRouteLazyRoute: typeof authenticatedEntitiesRouteLazyRouteWithChildren
  authenticatedMessagesRouteLazyRoute: typeof authenticatedMessagesRouteLazyRoute
  authenticatedPatientsRouteLazyRoute: typeof authenticatedPatientsRouteLazyRouteWithChildren
  authenticatedUsersRouteLazyRoute: typeof authenticatedUsersRouteLazyRouteWithChildren
}

const authenticatedRouteRouteChildren: authenticatedRouteRouteChildren = {
  authenticatedDashboardRouteRoute: authenticatedDashboardRouteRoute,
  authenticatedReferralsRouteRoute:
    authenticatedReferralsRouteRouteWithChildren,
  authenticatedAssessmentsRouteLazyRoute:
    authenticatedAssessmentsRouteLazyRouteWithChildren,
  authenticatedEntitiesRouteLazyRoute:
    authenticatedEntitiesRouteLazyRouteWithChildren,
  authenticatedMessagesRouteLazyRoute: authenticatedMessagesRouteLazyRoute,
  authenticatedPatientsRouteLazyRoute:
    authenticatedPatientsRouteLazyRouteWithChildren,
  authenticatedUsersRouteLazyRoute:
    authenticatedUsersRouteLazyRouteWithChildren,
}

const authenticatedRouteRouteWithChildren =
  authenticatedRouteRoute._addFileChildren(authenticatedRouteRouteChildren)

export interface FileRoutesByFullPath {
  '/': typeof authenticatedRouteRouteWithChildren
  '/dashboard': typeof authenticatedDashboardRouteRoute
  '/referrals': typeof authenticatedReferralsRouteRouteWithChildren
  '/sign-out': typeof unauthenticatedSignOutRouteRoute
  '/assessments': typeof authenticatedAssessmentsRouteLazyRouteWithChildren
  '/entities': typeof authenticatedEntitiesRouteLazyRouteWithChildren
  '/messages': typeof authenticatedMessagesRouteLazyRoute
  '/patients': typeof authenticatedPatientsRouteLazyRouteWithChildren
  '/users': typeof authenticatedUsersRouteLazyRouteWithChildren
  '/forgot-password': typeof unauthenticatedForgotPasswordRouteLazyRoute
  '/entities/': typeof authenticatedEntitiesIndexRouteRoute
  '/patients/': typeof authenticatedPatientsIndexRouteRoute
  '/users/': typeof authenticatedUsersIndexRouteRoute
  '/assessments/$id': typeof authenticatedAssessmentsIdRouteRoute
  '/entities/$entityId': typeof authenticatedEntitiesEntityIdRouteRoute
  '/patients/$patientId': typeof authenticatedPatientsPatientIdRouteRouteWithChildren
  '/referrals/$id': typeof authenticatedReferralsIdRouteRoute
  '/assessments/': typeof authenticatedAssessmentsIndexRouteLazyRoute
  '/referrals/': typeof authenticatedReferralsIndexRouteLazyRoute
  '/assessments/new': typeof authenticatedAssessmentsNewRouteLazyRoute
  '/patients/new': typeof authenticatedPatientsNewRouteLazyRoute
  '/referrals/new': typeof authenticatedReferralsNewRouteLazyRouteWithChildren
  '/users/$userId': typeof authenticatedUsersUserIdRouteLazyRouteWithChildren
  '/users/new': typeof authenticatedUsersNewRouteLazyRoute
  '/patients/$patientId/': typeof authenticatedPatientsPatientIdIndexRouteRoute
  '/patients/$patientId/care-plan': typeof authenticatedPatientsPatientIdCarePlanRouteRoute
  '/patients/$patientId/monthly-care-log': typeof authenticatedPatientsPatientIdMonthlyCareLogRouteRoute
  '/patients/$patientId/physician-summary': typeof authenticatedPatientsPatientIdPhysicianSummaryRouteRoute
  '/referrals/new/': typeof authenticatedReferralsNewIndexRouteLazyRoute
  '/users/$userId/': typeof authenticatedUsersUserIdIndexRouteLazyRoute
  '/patients/$patientId/advance-directives': typeof authenticatedPatientsPatientIdAdvanceDirectivesRouteLazyRoute
  '/patients/$patientId/allergies': typeof authenticatedPatientsPatientIdAllergiesRouteLazyRoute
  '/patients/$patientId/appointments': typeof authenticatedPatientsPatientIdAppointmentsRouteLazyRoute
  '/patients/$patientId/assessments': typeof authenticatedPatientsPatientIdAssessmentsRouteLazyRoute
  '/patients/$patientId/care-call': typeof authenticatedPatientsPatientIdCareCallRouteLazyRoute
  '/patients/$patientId/care-team': typeof authenticatedPatientsPatientIdCareTeamRouteLazyRoute
  '/patients/$patientId/communications': typeof authenticatedPatientsPatientIdCommunicationsRouteLazyRoute
  '/patients/$patientId/demographics': typeof authenticatedPatientsPatientIdDemographicsRouteLazyRoute
  '/patients/$patientId/diagnostics': typeof authenticatedPatientsPatientIdDiagnosticsRouteLazyRoute
  '/patients/$patientId/documents': typeof authenticatedPatientsPatientIdDocumentsRouteLazyRoute
  '/patients/$patientId/inpatient': typeof authenticatedPatientsPatientIdInpatientRouteLazyRoute
  '/patients/$patientId/insurance': typeof authenticatedPatientsPatientIdInsuranceRouteLazyRoute
  '/patients/$patientId/labs': typeof authenticatedPatientsPatientIdLabsRouteLazyRoute
  '/patients/$patientId/med-rec': typeof authenticatedPatientsPatientIdMedRecRouteLazyRoute
  '/patients/$patientId/medications': typeof authenticatedPatientsPatientIdMedicationsRouteLazyRoute
  '/patients/$patientId/notes': typeof authenticatedPatientsPatientIdNotesRouteLazyRoute
  '/patients/$patientId/outreach': typeof authenticatedPatientsPatientIdOutreachRouteLazyRoute
  '/patients/$patientId/preventative-qm': typeof authenticatedPatientsPatientIdPreventativeQmRouteLazyRoute
  '/patients/$patientId/problems': typeof authenticatedPatientsPatientIdProblemsRouteLazyRoute
  '/patients/$patientId/program-status': typeof authenticatedPatientsPatientIdProgramStatusRouteLazyRoute
  '/patients/$patientId/vitals': typeof authenticatedPatientsPatientIdVitalsRouteLazyRoute
  '/referrals/new/import': typeof authenticatedReferralsNewImportRouteLazyRoute
  '/referrals/new/pdf-import': typeof authenticatedReferralsNewPdfImportRouteLazyRoute
}

export interface FileRoutesByTo {
  '/': typeof authenticatedRouteRouteWithChildren
  '/dashboard': typeof authenticatedDashboardRouteRoute
  '/sign-out': typeof unauthenticatedSignOutRouteRoute
  '/messages': typeof authenticatedMessagesRouteLazyRoute
  '/forgot-password': typeof unauthenticatedForgotPasswordRouteLazyRoute
  '/entities': typeof authenticatedEntitiesIndexRouteRoute
  '/patients': typeof authenticatedPatientsIndexRouteRoute
  '/users': typeof authenticatedUsersIndexRouteRoute
  '/assessments/$id': typeof authenticatedAssessmentsIdRouteRoute
  '/entities/$entityId': typeof authenticatedEntitiesEntityIdRouteRoute
  '/referrals/$id': typeof authenticatedReferralsIdRouteRoute
  '/assessments': typeof authenticatedAssessmentsIndexRouteLazyRoute
  '/referrals': typeof authenticatedReferralsIndexRouteLazyRoute
  '/assessments/new': typeof authenticatedAssessmentsNewRouteLazyRoute
  '/patients/new': typeof authenticatedPatientsNewRouteLazyRoute
  '/users/new': typeof authenticatedUsersNewRouteLazyRoute
  '/patients/$patientId': typeof authenticatedPatientsPatientIdIndexRouteRoute
  '/patients/$patientId/care-plan': typeof authenticatedPatientsPatientIdCarePlanRouteRoute
  '/patients/$patientId/monthly-care-log': typeof authenticatedPatientsPatientIdMonthlyCareLogRouteRoute
  '/patients/$patientId/physician-summary': typeof authenticatedPatientsPatientIdPhysicianSummaryRouteRoute
  '/referrals/new': typeof authenticatedReferralsNewIndexRouteLazyRoute
  '/users/$userId': typeof authenticatedUsersUserIdIndexRouteLazyRoute
  '/patients/$patientId/advance-directives': typeof authenticatedPatientsPatientIdAdvanceDirectivesRouteLazyRoute
  '/patients/$patientId/allergies': typeof authenticatedPatientsPatientIdAllergiesRouteLazyRoute
  '/patients/$patientId/appointments': typeof authenticatedPatientsPatientIdAppointmentsRouteLazyRoute
  '/patients/$patientId/assessments': typeof authenticatedPatientsPatientIdAssessmentsRouteLazyRoute
  '/patients/$patientId/care-call': typeof authenticatedPatientsPatientIdCareCallRouteLazyRoute
  '/patients/$patientId/care-team': typeof authenticatedPatientsPatientIdCareTeamRouteLazyRoute
  '/patients/$patientId/communications': typeof authenticatedPatientsPatientIdCommunicationsRouteLazyRoute
  '/patients/$patientId/demographics': typeof authenticatedPatientsPatientIdDemographicsRouteLazyRoute
  '/patients/$patientId/diagnostics': typeof authenticatedPatientsPatientIdDiagnosticsRouteLazyRoute
  '/patients/$patientId/documents': typeof authenticatedPatientsPatientIdDocumentsRouteLazyRoute
  '/patients/$patientId/inpatient': typeof authenticatedPatientsPatientIdInpatientRouteLazyRoute
  '/patients/$patientId/insurance': typeof authenticatedPatientsPatientIdInsuranceRouteLazyRoute
  '/patients/$patientId/labs': typeof authenticatedPatientsPatientIdLabsRouteLazyRoute
  '/patients/$patientId/med-rec': typeof authenticatedPatientsPatientIdMedRecRouteLazyRoute
  '/patients/$patientId/medications': typeof authenticatedPatientsPatientIdMedicationsRouteLazyRoute
  '/patients/$patientId/notes': typeof authenticatedPatientsPatientIdNotesRouteLazyRoute
  '/patients/$patientId/outreach': typeof authenticatedPatientsPatientIdOutreachRouteLazyRoute
  '/patients/$patientId/preventative-qm': typeof authenticatedPatientsPatientIdPreventativeQmRouteLazyRoute
  '/patients/$patientId/problems': typeof authenticatedPatientsPatientIdProblemsRouteLazyRoute
  '/patients/$patientId/program-status': typeof authenticatedPatientsPatientIdProgramStatusRouteLazyRoute
  '/patients/$patientId/vitals': typeof authenticatedPatientsPatientIdVitalsRouteLazyRoute
  '/referrals/new/import': typeof authenticatedReferralsNewImportRouteLazyRoute
  '/referrals/new/pdf-import': typeof authenticatedReferralsNewPdfImportRouteLazyRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof RouteRoute
  '/(authenticated)': typeof authenticatedRouteRouteWithChildren
  '/(authenticated)/dashboard': typeof authenticatedDashboardRouteRoute
  '/(authenticated)/referrals': typeof authenticatedReferralsRouteRouteWithChildren
  '/(unauthenticated)/sign-out': typeof unauthenticatedSignOutRouteRoute
  '/(authenticated)/assessments': typeof authenticatedAssessmentsRouteLazyRouteWithChildren
  '/(authenticated)/entities': typeof authenticatedEntitiesRouteLazyRouteWithChildren
  '/(authenticated)/messages': typeof authenticatedMessagesRouteLazyRoute
  '/(authenticated)/patients': typeof authenticatedPatientsRouteLazyRouteWithChildren
  '/(authenticated)/users': typeof authenticatedUsersRouteLazyRouteWithChildren
  '/(unauthenticated)/forgot-password': typeof unauthenticatedForgotPasswordRouteLazyRoute
  '/(authenticated)/entities/': typeof authenticatedEntitiesIndexRouteRoute
  '/(authenticated)/patients/': typeof authenticatedPatientsIndexRouteRoute
  '/(authenticated)/users/': typeof authenticatedUsersIndexRouteRoute
  '/(authenticated)/assessments/$id': typeof authenticatedAssessmentsIdRouteRoute
  '/(authenticated)/entities/$entityId': typeof authenticatedEntitiesEntityIdRouteRoute
  '/(authenticated)/patients/$patientId': typeof authenticatedPatientsPatientIdRouteRouteWithChildren
  '/(authenticated)/referrals/$id': typeof authenticatedReferralsIdRouteRoute
  '/(authenticated)/assessments/': typeof authenticatedAssessmentsIndexRouteLazyRoute
  '/(authenticated)/referrals/': typeof authenticatedReferralsIndexRouteLazyRoute
  '/(authenticated)/assessments/new': typeof authenticatedAssessmentsNewRouteLazyRoute
  '/(authenticated)/patients/new': typeof authenticatedPatientsNewRouteLazyRoute
  '/(authenticated)/referrals/new': typeof authenticatedReferralsNewRouteLazyRouteWithChildren
  '/(authenticated)/users/$userId': typeof authenticatedUsersUserIdRouteLazyRouteWithChildren
  '/(authenticated)/users/new': typeof authenticatedUsersNewRouteLazyRoute
  '/(authenticated)/patients/$patientId/': typeof authenticatedPatientsPatientIdIndexRouteRoute
  '/(authenticated)/patients/$patientId/care-plan': typeof authenticatedPatientsPatientIdCarePlanRouteRoute
  '/(authenticated)/patients/$patientId/monthly-care-log': typeof authenticatedPatientsPatientIdMonthlyCareLogRouteRoute
  '/(authenticated)/patients/$patientId/physician-summary': typeof authenticatedPatientsPatientIdPhysicianSummaryRouteRoute
  '/(authenticated)/referrals/new/': typeof authenticatedReferralsNewIndexRouteLazyRoute
  '/(authenticated)/users/$userId/': typeof authenticatedUsersUserIdIndexRouteLazyRoute
  '/(authenticated)/patients/$patientId/advance-directives': typeof authenticatedPatientsPatientIdAdvanceDirectivesRouteLazyRoute
  '/(authenticated)/patients/$patientId/allergies': typeof authenticatedPatientsPatientIdAllergiesRouteLazyRoute
  '/(authenticated)/patients/$patientId/appointments': typeof authenticatedPatientsPatientIdAppointmentsRouteLazyRoute
  '/(authenticated)/patients/$patientId/assessments': typeof authenticatedPatientsPatientIdAssessmentsRouteLazyRoute
  '/(authenticated)/patients/$patientId/care-call': typeof authenticatedPatientsPatientIdCareCallRouteLazyRoute
  '/(authenticated)/patients/$patientId/care-team': typeof authenticatedPatientsPatientIdCareTeamRouteLazyRoute
  '/(authenticated)/patients/$patientId/communications': typeof authenticatedPatientsPatientIdCommunicationsRouteLazyRoute
  '/(authenticated)/patients/$patientId/demographics': typeof authenticatedPatientsPatientIdDemographicsRouteLazyRoute
  '/(authenticated)/patients/$patientId/diagnostics': typeof authenticatedPatientsPatientIdDiagnosticsRouteLazyRoute
  '/(authenticated)/patients/$patientId/documents': typeof authenticatedPatientsPatientIdDocumentsRouteLazyRoute
  '/(authenticated)/patients/$patientId/inpatient': typeof authenticatedPatientsPatientIdInpatientRouteLazyRoute
  '/(authenticated)/patients/$patientId/insurance': typeof authenticatedPatientsPatientIdInsuranceRouteLazyRoute
  '/(authenticated)/patients/$patientId/labs': typeof authenticatedPatientsPatientIdLabsRouteLazyRoute
  '/(authenticated)/patients/$patientId/med-rec': typeof authenticatedPatientsPatientIdMedRecRouteLazyRoute
  '/(authenticated)/patients/$patientId/medications': typeof authenticatedPatientsPatientIdMedicationsRouteLazyRoute
  '/(authenticated)/patients/$patientId/notes': typeof authenticatedPatientsPatientIdNotesRouteLazyRoute
  '/(authenticated)/patients/$patientId/outreach': typeof authenticatedPatientsPatientIdOutreachRouteLazyRoute
  '/(authenticated)/patients/$patientId/preventative-qm': typeof authenticatedPatientsPatientIdPreventativeQmRouteLazyRoute
  '/(authenticated)/patients/$patientId/problems': typeof authenticatedPatientsPatientIdProblemsRouteLazyRoute
  '/(authenticated)/patients/$patientId/program-status': typeof authenticatedPatientsPatientIdProgramStatusRouteLazyRoute
  '/(authenticated)/patients/$patientId/vitals': typeof authenticatedPatientsPatientIdVitalsRouteLazyRoute
  '/(authenticated)/referrals/new/import': typeof authenticatedReferralsNewImportRouteLazyRoute
  '/(authenticated)/referrals/new/pdf-import': typeof authenticatedReferralsNewPdfImportRouteLazyRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/dashboard'
    | '/referrals'
    | '/sign-out'
    | '/assessments'
    | '/entities'
    | '/messages'
    | '/patients'
    | '/users'
    | '/forgot-password'
    | '/entities/'
    | '/patients/'
    | '/users/'
    | '/assessments/$id'
    | '/entities/$entityId'
    | '/patients/$patientId'
    | '/referrals/$id'
    | '/assessments/'
    | '/referrals/'
    | '/assessments/new'
    | '/patients/new'
    | '/referrals/new'
    | '/users/$userId'
    | '/users/new'
    | '/patients/$patientId/'
    | '/patients/$patientId/care-plan'
    | '/patients/$patientId/monthly-care-log'
    | '/patients/$patientId/physician-summary'
    | '/referrals/new/'
    | '/users/$userId/'
    | '/patients/$patientId/advance-directives'
    | '/patients/$patientId/allergies'
    | '/patients/$patientId/appointments'
    | '/patients/$patientId/assessments'
    | '/patients/$patientId/care-call'
    | '/patients/$patientId/care-team'
    | '/patients/$patientId/communications'
    | '/patients/$patientId/demographics'
    | '/patients/$patientId/diagnostics'
    | '/patients/$patientId/documents'
    | '/patients/$patientId/inpatient'
    | '/patients/$patientId/insurance'
    | '/patients/$patientId/labs'
    | '/patients/$patientId/med-rec'
    | '/patients/$patientId/medications'
    | '/patients/$patientId/notes'
    | '/patients/$patientId/outreach'
    | '/patients/$patientId/preventative-qm'
    | '/patients/$patientId/problems'
    | '/patients/$patientId/program-status'
    | '/patients/$patientId/vitals'
    | '/referrals/new/import'
    | '/referrals/new/pdf-import'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/dashboard'
    | '/sign-out'
    | '/messages'
    | '/forgot-password'
    | '/entities'
    | '/patients'
    | '/users'
    | '/assessments/$id'
    | '/entities/$entityId'
    | '/referrals/$id'
    | '/assessments'
    | '/referrals'
    | '/assessments/new'
    | '/patients/new'
    | '/users/new'
    | '/patients/$patientId'
    | '/patients/$patientId/care-plan'
    | '/patients/$patientId/monthly-care-log'
    | '/patients/$patientId/physician-summary'
    | '/referrals/new'
    | '/users/$userId'
    | '/patients/$patientId/advance-directives'
    | '/patients/$patientId/allergies'
    | '/patients/$patientId/appointments'
    | '/patients/$patientId/assessments'
    | '/patients/$patientId/care-call'
    | '/patients/$patientId/care-team'
    | '/patients/$patientId/communications'
    | '/patients/$patientId/demographics'
    | '/patients/$patientId/diagnostics'
    | '/patients/$patientId/documents'
    | '/patients/$patientId/inpatient'
    | '/patients/$patientId/insurance'
    | '/patients/$patientId/labs'
    | '/patients/$patientId/med-rec'
    | '/patients/$patientId/medications'
    | '/patients/$patientId/notes'
    | '/patients/$patientId/outreach'
    | '/patients/$patientId/preventative-qm'
    | '/patients/$patientId/problems'
    | '/patients/$patientId/program-status'
    | '/patients/$patientId/vitals'
    | '/referrals/new/import'
    | '/referrals/new/pdf-import'
  id:
    | '__root__'
    | '/'
    | '/(authenticated)'
    | '/(authenticated)/dashboard'
    | '/(authenticated)/referrals'
    | '/(unauthenticated)/sign-out'
    | '/(authenticated)/assessments'
    | '/(authenticated)/entities'
    | '/(authenticated)/messages'
    | '/(authenticated)/patients'
    | '/(authenticated)/users'
    | '/(unauthenticated)/forgot-password'
    | '/(authenticated)/entities/'
    | '/(authenticated)/patients/'
    | '/(authenticated)/users/'
    | '/(authenticated)/assessments/$id'
    | '/(authenticated)/entities/$entityId'
    | '/(authenticated)/patients/$patientId'
    | '/(authenticated)/referrals/$id'
    | '/(authenticated)/assessments/'
    | '/(authenticated)/referrals/'
    | '/(authenticated)/assessments/new'
    | '/(authenticated)/patients/new'
    | '/(authenticated)/referrals/new'
    | '/(authenticated)/users/$userId'
    | '/(authenticated)/users/new'
    | '/(authenticated)/patients/$patientId/'
    | '/(authenticated)/patients/$patientId/care-plan'
    | '/(authenticated)/patients/$patientId/monthly-care-log'
    | '/(authenticated)/patients/$patientId/physician-summary'
    | '/(authenticated)/referrals/new/'
    | '/(authenticated)/users/$userId/'
    | '/(authenticated)/patients/$patientId/advance-directives'
    | '/(authenticated)/patients/$patientId/allergies'
    | '/(authenticated)/patients/$patientId/appointments'
    | '/(authenticated)/patients/$patientId/assessments'
    | '/(authenticated)/patients/$patientId/care-call'
    | '/(authenticated)/patients/$patientId/care-team'
    | '/(authenticated)/patients/$patientId/communications'
    | '/(authenticated)/patients/$patientId/demographics'
    | '/(authenticated)/patients/$patientId/diagnostics'
    | '/(authenticated)/patients/$patientId/documents'
    | '/(authenticated)/patients/$patientId/inpatient'
    | '/(authenticated)/patients/$patientId/insurance'
    | '/(authenticated)/patients/$patientId/labs'
    | '/(authenticated)/patients/$patientId/med-rec'
    | '/(authenticated)/patients/$patientId/medications'
    | '/(authenticated)/patients/$patientId/notes'
    | '/(authenticated)/patients/$patientId/outreach'
    | '/(authenticated)/patients/$patientId/preventative-qm'
    | '/(authenticated)/patients/$patientId/problems'
    | '/(authenticated)/patients/$patientId/program-status'
    | '/(authenticated)/patients/$patientId/vitals'
    | '/(authenticated)/referrals/new/import'
    | '/(authenticated)/referrals/new/pdf-import'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  RouteRoute: typeof RouteRoute
  authenticatedRouteRoute: typeof authenticatedRouteRouteWithChildren
  unauthenticatedSignOutRouteRoute: typeof unauthenticatedSignOutRouteRoute
  unauthenticatedForgotPasswordRouteLazyRoute: typeof unauthenticatedForgotPasswordRouteLazyRoute
}

const rootRouteChildren: RootRouteChildren = {
  RouteRoute: RouteRoute,
  authenticatedRouteRoute: authenticatedRouteRouteWithChildren,
  unauthenticatedSignOutRouteRoute: unauthenticatedSignOutRouteRoute,
  unauthenticatedForgotPasswordRouteLazyRoute:
    unauthenticatedForgotPasswordRouteLazyRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/(authenticated)",
        "/(unauthenticated)/sign-out",
        "/(unauthenticated)/forgot-password"
      ]
    },
    "/": {
      "filePath": "route.tsx"
    },
    "/(authenticated)": {
      "filePath": "(authenticated)/route.tsx",
      "children": [
        "/(authenticated)/dashboard",
        "/(authenticated)/referrals",
        "/(authenticated)/assessments",
        "/(authenticated)/entities",
        "/(authenticated)/messages",
        "/(authenticated)/patients",
        "/(authenticated)/users"
      ]
    },
    "/(authenticated)/dashboard": {
      "filePath": "(authenticated)/dashboard/route.tsx",
      "parent": "/(authenticated)"
    },
    "/(authenticated)/referrals": {
      "filePath": "(authenticated)/referrals/route.tsx",
      "parent": "/(authenticated)",
      "children": [
        "/(authenticated)/referrals/$id",
        "/(authenticated)/referrals/",
        "/(authenticated)/referrals/new"
      ]
    },
    "/(unauthenticated)/sign-out": {
      "filePath": "(unauthenticated)/sign-out/route.tsx"
    },
    "/(authenticated)/assessments": {
      "filePath": "(authenticated)/assessments/route.lazy.tsx",
      "parent": "/(authenticated)",
      "children": [
        "/(authenticated)/assessments/$id",
        "/(authenticated)/assessments/",
        "/(authenticated)/assessments/new"
      ]
    },
    "/(authenticated)/entities": {
      "filePath": "(authenticated)/entities/route.lazy.tsx",
      "parent": "/(authenticated)",
      "children": [
        "/(authenticated)/entities/",
        "/(authenticated)/entities/$entityId"
      ]
    },
    "/(authenticated)/messages": {
      "filePath": "(authenticated)/messages/route.lazy.tsx",
      "parent": "/(authenticated)"
    },
    "/(authenticated)/patients": {
      "filePath": "(authenticated)/patients/route.lazy.tsx",
      "parent": "/(authenticated)",
      "children": [
        "/(authenticated)/patients/",
        "/(authenticated)/patients/$patientId",
        "/(authenticated)/patients/new"
      ]
    },
    "/(authenticated)/users": {
      "filePath": "(authenticated)/users/route.lazy.tsx",
      "parent": "/(authenticated)",
      "children": [
        "/(authenticated)/users/",
        "/(authenticated)/users/$userId",
        "/(authenticated)/users/new"
      ]
    },
    "/(unauthenticated)/forgot-password": {
      "filePath": "(unauthenticated)/forgot-password/route.lazy.tsx"
    },
    "/(authenticated)/entities/": {
      "filePath": "(authenticated)/entities/index/route.tsx",
      "parent": "/(authenticated)/entities"
    },
    "/(authenticated)/patients/": {
      "filePath": "(authenticated)/patients/index/route.tsx",
      "parent": "/(authenticated)/patients"
    },
    "/(authenticated)/users/": {
      "filePath": "(authenticated)/users/index/route.tsx",
      "parent": "/(authenticated)/users"
    },
    "/(authenticated)/assessments/$id": {
      "filePath": "(authenticated)/assessments/$id/route.tsx",
      "parent": "/(authenticated)/assessments"
    },
    "/(authenticated)/entities/$entityId": {
      "filePath": "(authenticated)/entities/$entityId/route.tsx",
      "parent": "/(authenticated)/entities"
    },
    "/(authenticated)/patients/$patientId": {
      "filePath": "(authenticated)/patients/$patientId/route.tsx",
      "parent": "/(authenticated)/patients",
      "children": [
        "/(authenticated)/patients/$patientId/",
        "/(authenticated)/patients/$patientId/care-plan",
        "/(authenticated)/patients/$patientId/monthly-care-log",
        "/(authenticated)/patients/$patientId/physician-summary",
        "/(authenticated)/patients/$patientId/advance-directives",
        "/(authenticated)/patients/$patientId/allergies",
        "/(authenticated)/patients/$patientId/appointments",
        "/(authenticated)/patients/$patientId/assessments",
        "/(authenticated)/patients/$patientId/care-call",
        "/(authenticated)/patients/$patientId/care-team",
        "/(authenticated)/patients/$patientId/communications",
        "/(authenticated)/patients/$patientId/demographics",
        "/(authenticated)/patients/$patientId/diagnostics",
        "/(authenticated)/patients/$patientId/documents",
        "/(authenticated)/patients/$patientId/inpatient",
        "/(authenticated)/patients/$patientId/insurance",
        "/(authenticated)/patients/$patientId/labs",
        "/(authenticated)/patients/$patientId/med-rec",
        "/(authenticated)/patients/$patientId/medications",
        "/(authenticated)/patients/$patientId/notes",
        "/(authenticated)/patients/$patientId/outreach",
        "/(authenticated)/patients/$patientId/preventative-qm",
        "/(authenticated)/patients/$patientId/problems",
        "/(authenticated)/patients/$patientId/program-status",
        "/(authenticated)/patients/$patientId/vitals"
      ]
    },
    "/(authenticated)/referrals/$id": {
      "filePath": "(authenticated)/referrals/$id/route.tsx",
      "parent": "/(authenticated)/referrals"
    },
    "/(authenticated)/assessments/": {
      "filePath": "(authenticated)/assessments/index/route.lazy.tsx",
      "parent": "/(authenticated)/assessments"
    },
    "/(authenticated)/referrals/": {
      "filePath": "(authenticated)/referrals/index/route.lazy.tsx",
      "parent": "/(authenticated)/referrals"
    },
    "/(authenticated)/assessments/new": {
      "filePath": "(authenticated)/assessments/new/route.lazy.tsx",
      "parent": "/(authenticated)/assessments"
    },
    "/(authenticated)/patients/new": {
      "filePath": "(authenticated)/patients/new/route.lazy.tsx",
      "parent": "/(authenticated)/patients"
    },
    "/(authenticated)/referrals/new": {
      "filePath": "(authenticated)/referrals/new/route.lazy.tsx",
      "parent": "/(authenticated)/referrals",
      "children": [
        "/(authenticated)/referrals/new/",
        "/(authenticated)/referrals/new/import",
        "/(authenticated)/referrals/new/pdf-import"
      ]
    },
    "/(authenticated)/users/$userId": {
      "filePath": "(authenticated)/users/$userId/route.lazy.tsx",
      "parent": "/(authenticated)/users",
      "children": [
        "/(authenticated)/users/$userId/"
      ]
    },
    "/(authenticated)/users/new": {
      "filePath": "(authenticated)/users/new/route.lazy.tsx",
      "parent": "/(authenticated)/users"
    },
    "/(authenticated)/patients/$patientId/": {
      "filePath": "(authenticated)/patients/$patientId/index/route.tsx",
      "parent": "/(authenticated)/patients/$patientId"
    },
    "/(authenticated)/patients/$patientId/care-plan": {
      "filePath": "(authenticated)/patients/$patientId/care-plan/route.tsx",
      "parent": "/(authenticated)/patients/$patientId"
    },
    "/(authenticated)/patients/$patientId/monthly-care-log": {
      "filePath": "(authenticated)/patients/$patientId/monthly-care-log/route.tsx",
      "parent": "/(authenticated)/patients/$patientId"
    },
    "/(authenticated)/patients/$patientId/physician-summary": {
      "filePath": "(authenticated)/patients/$patientId/physician-summary/route.tsx",
      "parent": "/(authenticated)/patients/$patientId"
    },
    "/(authenticated)/referrals/new/": {
      "filePath": "(authenticated)/referrals/new/index/route.lazy.tsx",
      "parent": "/(authenticated)/referrals/new"
    },
    "/(authenticated)/users/$userId/": {
      "filePath": "(authenticated)/users/$userId/index/route.lazy.tsx",
      "parent": "/(authenticated)/users/$userId"
    },
    "/(authenticated)/patients/$patientId/advance-directives": {
      "filePath": "(authenticated)/patients/$patientId/advance-directives/route.lazy.tsx",
      "parent": "/(authenticated)/patients/$patientId"
    },
    "/(authenticated)/patients/$patientId/allergies": {
      "filePath": "(authenticated)/patients/$patientId/allergies/route.lazy.tsx",
      "parent": "/(authenticated)/patients/$patientId"
    },
    "/(authenticated)/patients/$patientId/appointments": {
      "filePath": "(authenticated)/patients/$patientId/appointments/route.lazy.tsx",
      "parent": "/(authenticated)/patients/$patientId"
    },
    "/(authenticated)/patients/$patientId/assessments": {
      "filePath": "(authenticated)/patients/$patientId/assessments/route.lazy.tsx",
      "parent": "/(authenticated)/patients/$patientId"
    },
    "/(authenticated)/patients/$patientId/care-call": {
      "filePath": "(authenticated)/patients/$patientId/care-call/route.lazy.tsx",
      "parent": "/(authenticated)/patients/$patientId"
    },
    "/(authenticated)/patients/$patientId/care-team": {
      "filePath": "(authenticated)/patients/$patientId/care-team/route.lazy.tsx",
      "parent": "/(authenticated)/patients/$patientId"
    },
    "/(authenticated)/patients/$patientId/communications": {
      "filePath": "(authenticated)/patients/$patientId/communications/route.lazy.tsx",
      "parent": "/(authenticated)/patients/$patientId"
    },
    "/(authenticated)/patients/$patientId/demographics": {
      "filePath": "(authenticated)/patients/$patientId/demographics/route.lazy.tsx",
      "parent": "/(authenticated)/patients/$patientId"
    },
    "/(authenticated)/patients/$patientId/diagnostics": {
      "filePath": "(authenticated)/patients/$patientId/diagnostics/route.lazy.tsx",
      "parent": "/(authenticated)/patients/$patientId"
    },
    "/(authenticated)/patients/$patientId/documents": {
      "filePath": "(authenticated)/patients/$patientId/documents/route.lazy.tsx",
      "parent": "/(authenticated)/patients/$patientId"
    },
    "/(authenticated)/patients/$patientId/inpatient": {
      "filePath": "(authenticated)/patients/$patientId/inpatient/route.lazy.tsx",
      "parent": "/(authenticated)/patients/$patientId"
    },
    "/(authenticated)/patients/$patientId/insurance": {
      "filePath": "(authenticated)/patients/$patientId/insurance/route.lazy.tsx",
      "parent": "/(authenticated)/patients/$patientId"
    },
    "/(authenticated)/patients/$patientId/labs": {
      "filePath": "(authenticated)/patients/$patientId/labs/route.lazy.tsx",
      "parent": "/(authenticated)/patients/$patientId"
    },
    "/(authenticated)/patients/$patientId/med-rec": {
      "filePath": "(authenticated)/patients/$patientId/med-rec/route.lazy.tsx",
      "parent": "/(authenticated)/patients/$patientId"
    },
    "/(authenticated)/patients/$patientId/medications": {
      "filePath": "(authenticated)/patients/$patientId/medications/route.lazy.tsx",
      "parent": "/(authenticated)/patients/$patientId"
    },
    "/(authenticated)/patients/$patientId/notes": {
      "filePath": "(authenticated)/patients/$patientId/notes/route.lazy.tsx",
      "parent": "/(authenticated)/patients/$patientId"
    },
    "/(authenticated)/patients/$patientId/outreach": {
      "filePath": "(authenticated)/patients/$patientId/outreach/route.lazy.tsx",
      "parent": "/(authenticated)/patients/$patientId"
    },
    "/(authenticated)/patients/$patientId/preventative-qm": {
      "filePath": "(authenticated)/patients/$patientId/preventative-qm/route.lazy.tsx",
      "parent": "/(authenticated)/patients/$patientId"
    },
    "/(authenticated)/patients/$patientId/problems": {
      "filePath": "(authenticated)/patients/$patientId/problems/route.lazy.tsx",
      "parent": "/(authenticated)/patients/$patientId"
    },
    "/(authenticated)/patients/$patientId/program-status": {
      "filePath": "(authenticated)/patients/$patientId/program-status/route.lazy.tsx",
      "parent": "/(authenticated)/patients/$patientId"
    },
    "/(authenticated)/patients/$patientId/vitals": {
      "filePath": "(authenticated)/patients/$patientId/vitals/route.lazy.tsx",
      "parent": "/(authenticated)/patients/$patientId"
    },
    "/(authenticated)/referrals/new/import": {
      "filePath": "(authenticated)/referrals/new/import/route.lazy.tsx",
      "parent": "/(authenticated)/referrals/new"
    },
    "/(authenticated)/referrals/new/pdf-import": {
      "filePath": "(authenticated)/referrals/new/pdf-import/route.lazy.tsx",
      "parent": "/(authenticated)/referrals/new"
    }
  }
}
ROUTE_MANIFEST_END */
